import React from "react";
import { useTranslation } from "react-i18next";
import { InputNumber, Radio } from "antd";
import { ReactComponent as PlayIcon } from "@/assets/icons/play.svg";
import { ReactComponent as FadeInIcon } from "@/assets/icons/fade-in-border.svg";
import { ReactComponent as FadeOutIcon } from "@/assets/icons/fade-out-border.svg";
import { ReactComponent as PauseIcon } from "@/assets/icons/pause.svg";
import "@/assets/audioCutSpeedVolume.less";

const AudioWorkCutRender = ({
  audioCutSpeedVolumeObj,
  playing,
  handleTimeStepChange,
  handleFade,
  handleCutOrTrim,
  tooglePlay,
}) => {
  const { t } = useTranslation(["audioCutAndSpeedAndVolume"]);
  let startRef = React.createRef();
  let endRef = React.createRef();
  return (
    <div className="work-cut">
      <div className="lft">
        {playing ? (
          <PauseIcon style={{ width: 32, height: 32, cursor: "pointer" }} onClick={tooglePlay} />
        ) : (
          <PlayIcon style={{ width: 32, height: 32, cursor: "pointer" }} onClick={tooglePlay} />
        )}
        <div className="fade-opr" onClick={() => handleFade("in")}>
          <FadeInIcon style={audioCutSpeedVolumeObj.fadeIn ? { color: "#8372FF" } : null} />
          <span>{t("Fade in")}</span>
        </div>
        <div className="fade-opr" onClick={() => handleFade("out")}>
          <FadeOutIcon style={audioCutSpeedVolumeObj.fadeOut ? { color: "#8372FF" } : null} />
          <span>{t("Fade out")}</span>
        </div>
      </div>
      <div className="center">
        <div>
          <span className="label">{t("Cut from")}</span>
          <InputNumber
            ref={startRef}
            value={audioCutSpeedVolumeObj.start}
            formatter={() => audioCutSpeedVolumeObj.start}
            onStep={value => handleTimeStepChange(value, "start")}
            step={0.01}
            onFocus={() => {
              if (startRef.current && !startRef.current.disabled) {
                startRef.current.disabled = true;
              }
            }}
          />
        </div>
        <div>
          <span className="label">{t("to")}</span>
          <InputNumber
            ref={endRef}
            value={audioCutSpeedVolumeObj.end}
            formatter={() => audioCutSpeedVolumeObj.end}
            onStep={value => handleTimeStepChange(value, "end")}
            step={0.01}
            onFocus={() => {
              if (endRef.current && !endRef.current.disabled) {
                endRef.current.disabled = true;
              }
            }}
          />
        </div>
      </div>
      <div className="rgt">
        <Radio.Group value={audioCutSpeedVolumeObj.cutOrTrim} onChange={handleCutOrTrim}>
          <Radio value="cut">{t("Extract selection")}</Radio>
          <Radio value="trim">{t("Delete selection")}</Radio>
        </Radio.Group>
      </div>
    </div>
  );
};

export default AudioWorkCutRender;
